import { useGetAllCarriersQuery } from "features/carriers/carrierSlice";
import { useEffect, useState } from "react";
import { Button, Grid } from "@material-ui/core";
import DropdownFilter from "components/DropdownFilter";
import CreateNewCarrier from "./CreateNewCarrier";
import { CarrierContacts } from "./CarrierContacts";
import { CarrierInfoStyle } from "./CarrierInfoStyle";
import { arrayToObject } from "utils/object-util";
import EditCarrierDialog from "features/carriers/EditCarrierDialog";

const ReservationCarrierInfo = ({ reservationDetails, setReservationDetails, onChangeValue, onChangePocField, displayError }) => {
    const classes = CarrierInfoStyle();

    let { data: carriers, error: carriersError, isLoading: isLoadingCarriers } = useGetAllCarriersQuery();
    carriers = carriers || [];

    const carrierLookup = arrayToObject(carriers);

    const [isNew, setIsNew] = useState(false);
    const [pocInfo, setPocInfo] = useState();
    const [openDialog, setOpenDialog] = useState(false);
    const [carrierToEdit, setCarrierToEdit] = useState();

    useEffect(() => {
        if (!!reservationDetails?.carrierInfo?.id) {
            setPocInfo(carrierLookup[reservationDetails?.carrierInfo?.id]?.pocInfo);
            setCarrierToEdit(carrierLookup?.[reservationDetails?.carrierInfo?.id])
        }
    }, [reservationDetails?.carrierInfo?.id, reservationDetails])

    const onCarrierTypeChange = (newCarrier) => {
        setIsNew(newCarrier);
        if (newCarrier) {
            onChangeValue("carrierInfo", { 'id': 0 }, 'reservationDetails')
        }
        if (!newCarrier) {
            setReservationDetails({ ...reservationDetails, ['carrierInfo']: undefined })
        }
    }

    return (
        <Grid container className={classes.carrierField} direction='row'>
            {!isNew ?
                <Grid container direction='column' item xs={6}>
                    <Grid item >
                        <div className={classes.labelCarrier}>
                            Carrier
                        </div>
                        <DropdownFilter
                            id="id"
                            onSelect={(val) => onChangeValue("id", val.id, 'carrierInfo')}
                            elementType="dropdown"
                            values={carriers}
                            withTypeAhead
                            shrink={reservationDetails?.carrierInfo?.id}
                            value={reservationDetails?.carrierInfo?.id}
                        />
                        <Button
                            onClick={() => { setOpenDialog(true); setCarrierToEdit(carrierLookup[reservationDetails?.carrierInfo?.id]) }}
                            variant='outlined'
                            disabled={!reservationDetails?.carrierInfo?.id}
                            className={classes.button}
                        >
                            Edit Carrier
                        </Button>
                    </Grid>
                </Grid> :
                <Grid item xs={6} className={classes.carrierTitle}>
                    New Carrier
                </Grid>
            }

            <Grid item xs={5} className={classes.radioContainer}>
                <div className={classes.input}>
                    <label className={classes.radioLable}>
                        <input className={classes.radioButton} type="radio" checked={!isNew} onChange={() => onCarrierTypeChange(!isNew)} />
                        Existing Carrier
                    </label>
                    <label className={classes.radioLable}>
                        <input className={classes.radioButton} type="radio" checked={isNew} onChange={() => onCarrierTypeChange(!isNew)} />
                        New Carrier
                    </label>
                </div>
            </Grid>

            {(reservationDetails?.carrierInfo?.id && !!pocInfo?.length) ?
                <CarrierContacts pocInfo={pocInfo} /> : null
            }

            {isNew && <CreateNewCarrier
                reservationDetails={reservationDetails}
                onChangeValue={onChangeValue}
                onChangePocField={onChangePocField}
                isNew={isNew}
                displayError={displayError}
            />}

            <EditCarrierDialog
                open={openDialog}
                carrier={carrierToEdit}
                setCarrier={setCarrierToEdit}
                onClose={() => setOpenDialog(false)}
            />
        </Grid>
    );
}

export default ReservationCarrierInfo;